<template>
  <div :class="rootClass">
    <b-row class="mb-2">
      <b-col lg="4" sm="12">
        <b-row align-v="center">
          <label :class="rootClass + '__phone-label'">Số điện thoại</label>
          <b-form-input
              ref="inputPhone"
              v-model="phone"
              :class="rootClass + '__phone-input'"
              placeholder="Nhập số điện thoại"
              v-on:keyup.enter="countCalls"
          ></b-form-input>
        </b-row>
      </b-col>
    </b-row>

    <b-row class="mb-2">
      <b-col lg="4" sm="12">
        <b-row align-v="center">
          <label :class="rootClass + '__date-label'">Chọn tháng</label>
          <b-form-input
              v-model="selectedMonth"
              type="month"
              :class="rootClass + '__date-input'"
              @change="updateDateRange"
          ></b-form-input>
        </b-row>
      </b-col>
    </b-row>

    <b-row class="">
      <p style="font-weight: 600; color: black; font-size: 14px;">
        Danh sách số điện thoại gần đây (tối đa 5 số)
      </p>
    </b-row>

    <b-row class="align-items-center">
      <b-col lg="2" sm="12" v-for="(item, index) in recentPhones" :key="index" class="mb-2">
        <b-row align-v="center">
          <label :class="rootClass + '__recent-phone-label'">Số liên hệ {{ index + 1 }}</label>
          <b-form-input
              v-model="recentPhones[index]"
              :class="rootClass + '__recent-phone-input'"
              :placeholder="'Số điện thoại ' + (index + 1)"
          ></b-form-input>
        </b-row>
      </b-col>
      <b-button
          :class="rootClass + '__search-btn'"
          class="redButton h-25"
          variant="danger"
          @click="countCalls"
      >Tra cứu
      </b-button>
    </b-row>

    <b-row class="mb-1" v-if="result && result.chiTiet && result.chiTiet.length > 0">
      <b-col cols="12">
        <table :class="rootClass + '__result-table'">
          <tr style="height: 3rem">
            <th class="--first-th">STT</th>
            <th>Số Thuê Bao</th>
            <th class="--last-th">Số Lần Xuất Hiện</th>
          </tr>
          <template v-for="(item, index) in result.chiTiet">
            <tr :key="index">
              <td class="--first-td">{{ item.STT }}</td>
              <td>{{ item.SoThueBao }}</td>
              <td class="--last-td">{{ item.TongSoLanXuatHien }}</td>
            </tr>
          </template>
        </table>
      </b-col>
    </b-row>

    <b-row v-if="showErrSearch || (result && result.chiTiet && result.chiTiet.length === 0)" style="justify-content: center;font-size: 18px">
      Không tìm thấy kết quả!
    </b-row>

  </div>
</template>

<script>
import {BButton, BCol, BFormInput, BRow} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import moment from "moment";

export default {
  components: {
    BRow,
    BCol,
    BFormInput,
    BButton,
  },
  data() {
    return {
      rootClass: "count-calls-by-date-range",
      phone: "",
      recentPhones: ["", "", "", "", ""],
      selectedMonth: moment().format("YYYY-MM"),
      startDate: "",
      endDate: "",
      showErrSearch: false,
      result: null,
    };
  },
  props: {
    searchPhone: String
  },
  mounted() {
    if (this.searchPhone) {
      this.phone = this.searchPhone;
    }
  },
  methods: {
    updateDateRange() {
      if (this.selectedMonth) {
        const [year, month] = this.selectedMonth.split('-');
        const firstDay = new Date(year, month - 1, 1);
        const lastDay = new Date(year, month, 0);

        this.startDate = this.formatDate(firstDay);
        this.endDate = this.formatDate(lastDay);
      }
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    countCalls() {
      this.showLoading("block")

      if (!this.phone) {
        this.showLoading("none")
        this.$refs.inputPhone.focus()
        this.$toast.error("Vui lòng nhập số điện thoại", {
          position: "top-right",
          timeout: 5000,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false
        });
        return;
      }

      if (!this.selectedMonth) {
        this.showLoading("none")
        this.$toast.error("Vui lòng chọn tháng", {
          position: "top-right",
          timeout: 5000,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false
        });
        return;
      }

      if (moment().startOf('month').diff(moment(this.selectedMonth, "YYYY-MM"), 'months') > 2) {
        this.showLoading("none")
        this.$toast.error("Chỉ được tra cứu trong vòng 3 tháng!", {
          position: "top-right",
          timeout: 5000,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false
        });
        return;
      }

      const recentPhonesList = this.recentPhones.filter(p => p && p.trim() !== "").map(p => {
        let phone = p.trim();
        if (phone.startsWith('84')) {
          return phone.substring(2);
        } else if (phone.startsWith('0')) {
          return phone.substring(1);
        }
        return phone;
      });
      this.updateDateRange()

      const requestData = {
        Phone: this.phone,
        RecentPhones: recentPhonesList,
        StartDate: this.startDate,
        EndDate: this.endDate
      };

      useJwt.post('count-calls-by-date-range', requestData).then((response) => {
        this.showLoading("none")
        if (response.data && response.data.result) {
          this.result = response.data.result;
          this.showErrSearch = false;
          this.$toast.success("Tra cứu thành công", {
            position: "top-right",
            timeout: 5000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: true,
            closeButton: "button",
            icon: true,
            rtl: false
          });
        } else {
          this.showErrSearch = true;
          this.result = null;
        }
        console.log("countCallsByDateRange", response.data);
      }).catch((error) => {
        this.showLoading("none")
        this.showErrSearch = true;
        this.result = null;
        this.$toast.error("Có lỗi xảy ra: " + (error.response?.data?.message || error.message), {
          position: "top-right",
          timeout: 5000,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false
        });
        console.log(error);
      });
    },
    showLoading(options) {
      document.getElementById('loading-bg').style.display = options;
    },
  }
};
</script>

<style lang="scss" scoped>
.count-calls-by-date-range {
  position: relative;
  font-size: 16px;
  font-family: "Times New Roman";
  min-height: 500px;

  &__phone-label {
    font-weight: 500;
    color: black;
    font-size: 14px;
    margin-right: 0.3rem;
    width: 120px;
  }

  &__phone-input {
    font-weight: 500;
    color: black;
    font-size: 14px;
    width: 250px;
  }

  &__date-label {
    font-weight: 500;
    color: black;
    font-size: 14px;
    margin-right: 0.3rem;
    width: 120px;
  }

  &__date-input {
    font-weight: 500;
    color: black;
    font-size: 14px;
    width: 250px;
  }

  &__recent-phone-label {
    font-weight: 500;
    color: black;
    font-size: 14px;
    margin-right: 0.3rem;
    width: 200px;
  }

  &__recent-phone-input {
    font-weight: 500;
    color: black;
    font-size: 14px;
    width: 250px;
  }

  &__search-btn {
    border-radius: 40px;
  }

  &__result-table {
    background: white;
    border-radius: 16px;
    width: 100%;
    text-align: center;

    tr {
      height: 30px;
    }

    tr th,
    tr td {
      border: 0.299185px solid rgba(184, 184, 184, 0.5);
    }

    th {
      background-color: #ED1F24;
      color: white;
      font-weight: 500;
      font-size: 14px;
    }

    td {
      color: black;
      font-size: 14px;
    }

    .--first-th {
      border-radius: 12px 0px 0px 0px;
      border-right: unset;
      border-left: unset;
    }

    .--last-th {
      border-radius: 0px 12px 0px 0px;
      border-right: unset;
      border-left: unset;
    }

    .--first-td {
      border-right: unset;
      border-left: unset;
    }

    .--last-td {
      border-right: unset;
      border-left: unset;
    }
  }
}

.redButton {
  background-color: #ED1F24 !important;
  border-color: #ED1F24 !important;
}

@media screen and (max-width: 576px) {
  .count-calls-by-date-range {
    &__phone-label {
      width: 100%;
    }

    &__phone-input {
      width: 100%;
    }

    &__date-label {
      width: 100%;
    }

    &__date-input {
      width: 100%;
    }

    &__recent-phone-label {
      width: 100%;
    }

    &__recent-phone-input {
      width: 100%;
    }
  }
}
</style>
